import AppTitle from '@theme/components/atom/AppTitle'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import Divider from '@theme/components/molecule/Divider'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import LayoutBase from '@theme/components/shop/LayoutBase'
import SeoMixin from '~/mixins/SeoMixin'

export default {
  components: {
    AppTitle,
    Breadcrumbs,
    Divider,
    LayoutBase,
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('PageFiles.breadcrumbs.files'),
          path: this.$route.path,
        },
      ],
    }
  },
  head() {
    return this.getSeoHead({ yamlKey: 'PageFiles' })
  },
  mixins: [ImageUrlMixin, SeoMixin],
}
